"use strict";

import { Application } from "../../main/application.js";
import { Time } from "../core/time.js";

export class Timer {
    constructor(config) {
        this.triggerEvery = config.triggerEvery;
        this.callback = config.callback;

        this.started = false;
        this.nextTrigger = 0;

        if (config.autoUpdate) {
            Application.main.ticker.add(() => this.validate());
        }

        if (config.autoStart) {
            this.start();
        }
    }

    start() {
        if (this.started) return;

        this.started = true;
        this.nextTrigger = Time.now + this.triggerEvery;
    }

    stop() {
        if (!this.started) return;

        this.started = false;
        this.nextTrigger = 0;
    }

    validate() {
        if (!this.started) return false;

        if (Time.now >= this.nextTrigger) {
            this.callback?.();
            this.nextTrigger = Time.now + this.triggerEvery;
            return true;
        }

        return false;
    }

    reset() {
        if (!this.started) return;
        
        this.nextTrigger = Time.now + this.triggerEvery;
    }
}